import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../../Context/AuthContext";

export const PerformanceNavbar = () => {
  const { user } = useContext(AuthContext);
  return (
    <div className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box-two">
              <h4 className="page-title"></h4>
              <h1 className="welcome_text">PERFORMANCE MANAGEMENT</h1>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>

        <div>
          <nav
            className="navbar navbar-light navbar-expand-md bg-faded"
            style={{
              boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.075)",
            }}
          >
            {/* <a
                            href="/"
                            className="navbar-brand d-flex w-50 mr-auto"
                        ></a> */}
            <ul className="navbar-nav w-100 mr-auto justify-content-center">
              <li className="nav-item ml-auto">
                <Link
                  className="nav-link"
                  to="/dashboard/performance"
                  style={{ borderRight: "3px solid #243050" }}
                >
                  PERFORMANCE
                </Link>
              </li>
              {user.data.user.roles && user.data.user.roles.name === "admin" ? (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/dashboard/performance/employee-review"
                    style={{ borderRight: "3px solid #243050" }}
                  >
                    EMPLOYEES
                  </Link>
                </li>
              ) : null}
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/dashboard/performance/history-review"
                  style={{ borderRight: "3px solid #243050" }}
                >
                  MY HISTORY
                </Link>
              </li>
              {user.data.user.roles && user.data.user.roles.name === "admin" ? (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/dashboard/performance/employee-history-review"
                    style={{ borderRight: "3px solid #243050" }}
                  >
                    EMPLOYEES HISTORY
                  </Link>
                </li>
              ) : null}
            </ul>
            <div
              className="navbar-collapse collapse w-100"
              id="collapsingNavbar3"
            >
              <ul className="nav navbar-nav ml-auto w-100 justify-content-end">
                <li className="nav-item ml-auto"></li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/perfomancemanagement/reusedcomponent/navbar.js